import React, { PropsWithChildren } from 'react'

import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import {
  fetchCampaignBillings,
  selectCampaignBillingList,
  selectIsFetchingBilling,
} from '@store/billings'
import { isEmpty } from '@utils'
import PurchaseWrapper from './Wrapper'

const PurchaseCampaignWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch()
  const { hasPurchases, isLoading, enableFetch } = useSelector((state: IApplicationState) => {
    const hasPurchases = !isEmpty(selectCampaignBillingList(state))
    const isLoading = !hasPurchases && !!selectIsFetchingBilling(state)
    return { isLoading, hasPurchases, enableFetch: !hasPurchases }
  }, shallowEqual)

  return (
    <PurchaseWrapper
      hasPurchases={hasPurchases}
      isLoading={isLoading}
      enableFetch={enableFetch}
      fetchList={() => dispatch(fetchCampaignBillings())}
    >
      {children}
    </PurchaseWrapper>
  )
}

export default PurchaseCampaignWrapper
